import {
  getData,
  postData,
  getDataCache
} from './api-base.service';
import {
  guid
} from "@/config/mUtils";

export const getContractList = (contractType, getRelated) => {
  if (typeof getRelated == "undefined"){
    getRelated = false;
  }
  let result = getData('/Contract/GetContractList', {
    contractType,
    getRelated
  });
  return result;
}

export const getContractsDict = (contractTypes) => {
  let result = getData('/Contract/GetContractsDict', {
    contractTypes
  });
  return result;
}

export const getContractViewModelList = async (isCache) => {
  let data = {
    contractType: 0
  };
  return getDataCache('/Contract/GetContractViewModelList', data, isCache);
}

export const getContractPageData = async (condition) => {
  let data = condition;
  return postData('/Contract/GetContractPageData', data);
}

export const saveContract = (data) => {
  return postData('/Contract/SaveContract', data)
}

export const getAllContractList = () => {
  let result = getData('/Contract/GetAllContractList');
  return result;
}

export const getUncheckedStudentContracts = (param) => {
  let result = getData('/Contract/GetUncheckedStudentContracts');
  return result;
}

export const signContracts = (workflowIds, workflowCourseIds) => {
  let data = {
    WorkflowIds: workflowIds,
    WorkflowCourseIds: workflowCourseIds
  };
  let result = postData('/Contract/SignContracts', data);
  return result;
}

export const checkStudentHasUnsignedContracts = () => {
  return getData('/Contract/CheckStudentHasUnsignedContracts');
}

export const getStudentWorkflowContracts = (workflowId) => {
  return getData('/Contract/GetStudentWorkflowContracts', {workflowId: workflowId});
}

export const checkWorkflowHasUnsignedContracts = (workflowId) => {
  return getData('/Contract/CheckWorkflowHasUnsignedContracts', {workflowId: workflowId});
}

export const getUncheckedStudentSpeedupCourseReplayRules = () => {
  return getData('/Contract/GetUncheckedStudentSpeedupCourseReplayRules');
}

export const signStudentSpeedupCourseReplayRules = (studentSpeedupCourseIds) => {
  let data = {
    StudentSpeedupCourseIds: studentSpeedupCourseIds
  };
  return postData('/Contract/SignStudentSpeedupCourseReplayRules', data);
}


// WEBPACK FOOTER //
// ./src/service/contract.service.js